import { createVNode as l, mergeProps as a } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/VisibleFilledStandard.js";
import d from "../components/PfIcon.js";
const r = (e, t) => {
  const i = {
    ...e,
    ...t.attrs
  };
  return l(d, a(i, {
    icon: o
  }), null);
};
r.displayName = "VisibleFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
